// Importing react modules
import styled from "@emotion/styled/macro";
import { keyframes } from "@emotion/core";
import React from "react";
import ReactGA from "react-ga";

import ButtonBase from "./ButtonBase";
import icon from "../../res/btn_bobble_reveal.svg";
import badge from "../../res/img_bonus.svg";

const Button = styled(ButtonBase)`
  &:before {
    background-image: url(${icon});
  }
  &:after {
    content: "Bonus";
  }
`;

const bounce = keyframes`
  from, 20%, 53%, 80%, to {
    transform: translate3d(0,0,0);
  }

  40%, 43% {
    transform: translate3d(-14%, 0, 0);
  }

  70% {
    transform: translate3d(-7%, 0, 0);
  }

  90% {
    transform: translate3d(-2%, 0, 0);
  }
`;

const Indicator = styled("div")`
  width: 62.5px;
  height: 33px;
  background: url(${badge}) no-repeat right center;
  background-size: contain;
  position: absolute;
  top: 13px;
  left: -55px;
  animation: ${bounce} 1.5s ease infinite;
`;

let scratched: boolean = false;

const BonusButton = ({ onClick, isScratched, ...rest }: any) => (
  <Button
    onMouseDown={event => event.stopPropagation()}
    onClick={() => {
      ReactGA.event({
        category: "bobblehead interaction",
        action: "view bonus",
        label: "via button"
      });
      scratched = true;
      onClick();
    }}
    {...rest}
  >
    {!scratched && <Indicator />}
  </Button>
);

export default BonusButton;
